angular.module('gym.grading').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.grading.gradings', {
    abstract: true,
    template: '<ui-view>'
  }).state('gym.grading.gradings.list', {
    url: '/gradings',
    template: require('templates/gyms/grading/gradings/index.html.slim'),
    reloadOnSearch: false
  }).state('gym.grading.gradings.new', {
    url: '/gradings/new?quickPromoteContactId&quickPromoteContactName',
    template: require('templates/gyms/grading/gradings/new.html.slim'),
    reloadOnSearch: false
  }).state('gym.grading.gradings.show', {
    url: '/gradings/:gradingId',
    controller: 'ShowGradingCtrl',
    template: require('templates/gyms/grading/gradings/show.html.slim'),
    resolve: {
      grading: ["$stateParams", "Gradings", function($stateParams, Gradings) {
        return Gradings.get($stateParams.gradingId);
      }]
    }
  });
}]);
